// Lib
import React from 'react';
import PropTypes from 'prop-types';

export default (DecoratedComponent) => {
    class columnSaveSizeResizeDecorator extends React.Component {
        handleDoubleClick = () => {
            const { elementId, dispatchUpdateElement } = this.props;

            return dispatchUpdateElement({
                id: elementId,
                changes: {
                    width: null,
                },
            });
        };

        render() {
            return <DecoratedComponent {...this.props} handleDoubleClick={this.handleDoubleClick} />;
        }
    }

    columnSaveSizeResizeDecorator.propTypes = {
        elementId: PropTypes.string,
        element: PropTypes.object,
        gridSize: PropTypes.number,
        setElementSizeAndPosition: PropTypes.func,
        dispatchUpdateElement: PropTypes.func,
    };

    return columnSaveSizeResizeDecorator;
};
